import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { Grid } from '@material-ui/core';
import { Icon } from '@hydra/common/components';
import get from 'lodash/get';

import List from '@hydra/routes/crawler/components/List';
import DCUrl from '@hydra/routes/crawler/utils/DCUrl';
import DCUrlLabel from '@hydra/routes/crawler/components/DCUrlLabel';

export class NonIndexablePagesRow extends React.Component {
  static propTypes = {
    issue: PropTypes.object,
    columnStyles: PropTypes.array,
    relay: PropTypes.object
  }

  render () {
    const {
      columnStyles,
      issue,
      className: classNameProp
    } = this.props;
    const domain = get(this.props, ['relay', 'route', 'params', 'url'], '');
    const issueUrl = new DCUrl(domain, issue.url);
    const sourceUrl = new DCUrl(domain, issue.source_url);

    return (
      <Grid container className={classNameProp} alignItems='flex-start'>
        <Grid item {...columnStyles[0]}>
          <DCUrlLabel url={issueUrl} severity={3} />
        </Grid>
        <Grid item {...columnStyles[1]}>
          <DCUrlLabel url={sourceUrl} severity={3} />
        </Grid>
        <Grid item {...columnStyles[2]}>
          <List style='default' items={issue.noindex_types} />
        </Grid>
        <Grid item {...columnStyles[3]}>
          {
            (issue.sitemap_url)
              ? <Icon type='check' color='success-dark' size='sm' />
              : <Icon type='cross' color='error-dark' size='sm' />
          }
        </Grid>
      </Grid>
    );
  }
}

export default createFragmentContainer(NonIndexablePagesRow, {
  issue: graphql`
    fragment NonIndexablePagesRow_issue on NoindexedPage {
      id
      type
      severity
      url
      source_url
      noindex_types
      sitemap_url
    }
  `
});
